import { registerPlugin } from '@capacitor/core';
import { env } from './env';

/** Plugin nativo propio (android/.../FullScreenAlertPlugin.java). */
interface FullScreenAlertPlugin {
  status(): Promise<{ allowed: boolean }>;
  openSettings(): Promise<void>;
}
const FullScreenAlert = registerPlugin<FullScreenAlertPlugin>('FullScreenAlert');

/** ¿Puede la app mostrar solicitudes a pantalla completa con el teléfono bloqueado? (Android 14+ lo pide al usuario) */
export async function fullScreenAlertAllowed(): Promise<boolean> {
  if (!env.isNative) return true;
  try {
    return (await FullScreenAlert.status()).allowed;
  } catch {
    return true; // APK anterior sin el plugin
  }
}

export const openFullScreenAlertSettings = () => FullScreenAlert.openSettings().catch(() => undefined);
